import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import { generateSchemaAndUiSchema } from '../OnEdit/onEdit';
import { postTempConfigFile } from '../../../actions';

export const generateAction = (formData, assetTypes, config, currentAction) => {
  const asset = assetTypes.find(type => type.id === formData.asset);
  const actionProperties = generateSchemaAndUiSchema(
    config,
    asset.attributes,
    false
  );

  const action = {
    id: currentAction ? currentAction.id : new Date().getTime().toString(),
    name: formData.name,
    description: formData.description,
    assetType: asset.id,
    schema: {
      title: formData.formAssetTitle,
      type: 'object',
      properties: actionProperties.properties
    },
    uiSchema: actionProperties.uiSchema,
    actionRef: {
      method: formData.type,
      name: 'apiSigneBlock-asset-service-STAGE-asset',
      path: '/asset'
    },
    mandatory: true
  };
  return action;
};

export function parseAction (action, assetTypes) {
  return {
    id: action.id,
    name: action.name,
    description: action.description,
    type: action.actionRef.method === 'POST' ? 'Crear' : 'Modificar',
    formAssetTitle: action.schema.title,
    asset: assetTypes.find(type => type.id === action.assetType).name
  };
}

export function generateSchemaAssetType (asset, currentAction) {
  const schemaAssetType = {
    type: 'object',
    title: 'Seleccione los atributos y sus propiedades:',
    properties: {}
  };
  const uiSchemaAssetType = {
    classNames: 'form-action-step-2'
  };
  if (asset.attributes) {
    asset.attributes.forEach(element => {
      let key;
      if (element.type === 'asset') {
        key = 'assets';
      } else {
        key = element.attrName;
      }
      schemaAssetType.properties[key] = {
        type: 'object',
        title: element.title,
        properties: {
          use: {
            type: 'boolean',
            title: 'Show',
            default: currentAction && currentAction.schema.properties[key] ? currentAction.schema.properties[key].use : false
          },
          required: {
            type: 'boolean',
            title: 'Required',
            default: currentAction && currentAction.schema.required ? currentAction.schema.required.includes(key) : false
          },
          readOnly: {
            type: 'boolean',
            title: 'Read only',
            default: currentAction && currentAction.schema.properties[key] ? currentAction.schema.properties[key].readOnly : false
          }
        }
      };
      uiSchemaAssetType[key] = {
        classNames: 'form-action-step-2-group',
        use: {
          classNames: 'form-action-step-2-item',
          'ui:field': 'Checkbox',
          noLegend: true
        },
        required: {
          classNames: 'form-action-step-2-item',
          'ui:field': 'Checkbox',
          noLegend: true
        },
        readOnly: {
          classNames: 'form-action-step-2-item',
          'ui:field': 'Checkbox',
          noLegend: true
        }
      };
    });
  }

  schemaAssetType.properties['ui:ordering'] = {
    type: 'array',
    title: funcTranslateHelper('Ordene los atributos'),
    default: currentAction && currentAction.uiSchema['ui:order'] ? asset.attributes.map(e => e.title).sort((a, b) => currentAction.uiSchema['ui:order'].indexOf(a) - currentAction.uiSchema['ui:order'].indexOf(b)) : asset.attributes.map(e => e.title),
    items: {
      type: 'string',
      default: 'unidentified',
      classNames: 'form-action-step-2-order-item'

    }
  };
  uiSchemaAssetType['ui:ordering'] = {
    classNames: 'form-action-step-2-order',
    'ui:options': {
      addable: false,
      removable: false
    }
  };
  return [schemaAssetType, uiSchemaAssetType];
}

export function mergeActions (action, asset) {
  Object.entries(asset).reduce((acc, current) => {
    const key = current[0];
    if (acc.uiSchema[key]) {
      // If attribute is required
      if (current[1].required) {
        if (acc.schema.required === undefined) {
          acc.schema.required = [key];
        } else {
          acc.schema.required.push(key);
          acc.schema.required = Array.from(new Set(acc.schema.required));
        }
      } else {
        if (acc.schema.required) {
          acc.schema.required = acc.schema.required.filter(elemt => elemt !== key);
        }
      }
      // If should show this attribute
      if (current[1].use) {
        if (acc.uiSchema[key] && acc.uiSchema[key]['ui:widget']) {
          delete acc.uiSchema[key]['ui:widget'];
        }
        acc.schema.properties[key].use = true;
      } else {
        acc.uiSchema[key] = Object.assign(acc.uiSchema[key], {
          'ui:widget': 'hidden'
        });
        if (acc.schema.properties[key]) {
          acc.schema.properties[key].use = false;
        }
      }
      if (current[1].readOnly && acc.schema.properties[key]) {
        acc.schema.properties[key].readOnly = true;
        acc.schema.properties[key].disabled = true;
      } else if (acc.schema.properties[key]) {
        acc.schema.properties[key].readOnly = false;
        acc.schema.properties[key].disabled = false;
      }
    } else {
      if (Array.isArray(current[1]) && key === 'ui:ordering') {
        try {
          const map = current[1].map(item => Object.entries(acc.schema.properties)
            .filter((prop) => {
              return prop[1].title === item;
            })[0][0]);
          acc.uiSchema['ui:order'] = map;
        } catch (e) {
          acc.uiSchema['ui:order'] = ['*'];
        }
      }
    }
    return acc;
  }, action);
  return action;
}

export const saveConfig = async (config, saveTempConfigFile, setNotification, open, toggleForm) => {
  const res = await postTempConfigFile(config);
  if (res.message === 'OK') {
    saveTempConfigFile(config);
    setNotification({
      type: 'success',
      message: funcTranslateHelper('Builder.Message.realizado')
    });
  } else {
    setNotification({
      type: 'error',
      message: funcTranslateHelper('Builder.Message.error')
    });
  }

  setTimeout(() => setNotification(null), 2000);
  if (open) toggleForm();
};
